
export const fullname = (user) => {
    if ( user == null ) return ''
    if (user.firstName==null && user.lastName==null && user.email != null) return user.email
    return user.firstName + ' ' + user.lastName
}